"use strict";

var React = require('react'),
    ReactRouter = require('react-router'),
    BS = require('react-bootstrap'),
    DocumentTitle = require('react-document-title'),
    cx = require('classnames'),
    CurrentUser = require('../../../shared/CurrentUser'),
    Constants = require('../../../constants'),
    Footer = require('../Footer');

var DevelopmentUnavailable = React.createClass({displayName: "DevelopmentUnavailable",
 
    getDefaultProps: function() {
        return {};
    },

    updateState: function() {
        return {};
    },

    getInitialState: function() {
        return this.updateState();
    },

    componentWillReceiveProps: function(){
        this.setState(this.updateState());
    },

    render: function() {
        var title = 'Agent Toolbox: Devleopment Not Found';

        return (
            React.createElement("div", {className: "wrapper"}, 
                React.createElement(DocumentTitle, {title: 'NCH - ' + title}), 
                React.createElement("div", {className: "container content"}, 
                    React.createElement("div", {className: "row"}, 
                        React.createElement("div", {className: "col-sm-6 col-sm-offset-3"}, 
                            React.createElement(BS.Panel, {className: "panel-split-header", bsStyle: "danger", header: (React.createElement("h2", null, "Listing Not Found!"))}, 
                                "Listing could not be located or is inactive."
                            ), 
                            React.createElement(Footer, {trackerId: "agent-toolbox-error-development-not-found"})
                        )
                    )
                )
            )
        );
    }
});
module.exports = DevelopmentUnavailable;
